import { useTranslation } from "react-i18next";
import { IconDispatcher } from "shared/ui-basics";
import styled from "styled-components";

interface FilterButtonProps {
	title: string;
	selectedIds: string[];
	icon: string;
}

export const FilterButton: React.FC<FilterButtonProps> = ({ title, selectedIds, icon }) => {
	const { t } = useTranslation();

	return (
		<Container>
			<div className="me-2">{IconDispatcher(icon)}</div>
            {selectedIds?.length > 0 && <Counter>{`${selectedIds?.length} /`} </Counter>}
			<Title>{t(title)}</Title>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	height: 32px;
	padding: 8px;
	border-radius: 4px;
	border: 1px solid #f0f0f0;
	background: #f0f0f0;
	:hover {
		border: 1px solid #333;
	}
`;

const Counter = styled.div`
	width: 25px;
`;

const Title = styled.div`
	display: flex;
	align-items: center;
	white-space: nowrap;
	color: #262626;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
`;
